export default "__VITE_ASSET__DpUwG4EP__"